module.exports = require('./helpers/bundle-url').getBundleURL('fmqSe') + "logo.c51670a8.svg";